<template>
  <div>
    <div class="uk-flex uk-flex-column uk-margin uk-container" >

      <!-- uk-flex-center uk-flex-middle  -->
      <h1>{{post.title}}</h1>
      <div class="widget-content" v-html="post.content"></div>

    </div>


  </div>
</template>


<script>
//import { AUTH_LOGOUT } from "@/store/actions/auth.js";
import SyncLoader from 'vue-spinner/src/SyncLoader.vue'
import axios from "axios";
import { settings } from "@/settings";

let API_SERVER = settings.API_SERVER;

export default {
  name: "BlogPost",
  metaInfo() {
    return {
      title: this.post.title,
      meta: [
        { name: 'description', content: this.post.title,'vmid': 'og:image' },
        { name: 'og:image', content: this.post.featimage, 'vmid': 'og:image' },
      ]
    }
  },
  data: function () {
    return {
    //post: {title: "blog post title",featimage:"",content:"",permalink:""},
    post: {},
  }},
  methods: {
    logout: function() {
      this.$store.dispatch(AUTH_LOGOUT).then(() => this.$router.push("/login"));
    },
    getPost() {
        var _vm = this;
        var clean_slug = this.$route.params.slug;
        clean_slug = clean_slug.replace(".html","");
        if(clean_slug == "index"){
            console.log("blog post index.html route must go one level back");
            console.log(this.$route);
            clean_slug = "*";
            document.location = "/news/";
        }
        axios
          .get(API_SERVER + '/_/items/news?filter[slug][eq]='+clean_slug)
          .then(response => {
            if(response.data.data.length > 0){
              _vm.post = response.data.data[0];
              _vm.post.title = _vm.post.title;
              if(_vm.post.featimage != undefined && _vm.post.featimage > 0){
                this.getFeatImage(_vm.post.featimage);
              }
              else {
                //_vm.$emit('updateHead');
              }
            }
        });
    },
    getFeatImage: function(file_id){
      //console.log("getFeatImage id:" + file_id);
      if(file_id>0){
        var _vm = this;
        axios
          .get(API_SERVER + '/_/files/' + file_id)
          .then(response => {
            //console.log(response.data.data.data.full_url);
            if(response.data.data.data.full_url != undefined){
              _vm.post.featimage = response.data.data.data.full_url;
              //_vm.$emit('updateHead');
            }
        });
      }
      
      if(_vm.post.featimage == "") {
        //_vm.$emit('updateHead');
      }
    }
  },
  created() {
      this.getPost()
  },
  mounted: function () {
    //console.log("mounted");
    //this.loadWebWidgets();
  },
};
</script>
